import { FC, ReactElement } from 'react'
import { useInterval, useToggle } from 'react-nb-hooks'

const WithRerenderInterval: FC<{ children: ReactElement }> = ({ children }) => {
  const [visible, toggle] = useToggle(true)

  useInterval(() => toggle(), 1000)

  return visible && children
}

export default WithRerenderInterval
